import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyToEvolve() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="38971" id="convert-land-to-cash" className="relative w-full overflow-hidden bg-gradient-to-br from-accent via-accent/90 to-accent/80 py-32 lg:py-48">
      {}
      <div className="absolute inset-0 z-0 flex items-center justify-center opacity-20 mix-blend-multiply pointer-events-none">
        {}
        <div className="w-[150%] min-w-[100vw] max-w-none">
          <AspectRatio ratio={16 / 9}>
            <video autoPlay loop muted playsInline poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1610811/img/silk_abstract_poster.png" className="h-full w-full object-cover grayscale brightness-50">
              {}
              <source src="/video/silk_flow_loop.mp4" type="video/mp4" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1610811/img/silk_abstract_poster.png" alt="Abstract flowing silk background" className="h-full w-full object-cover" />
            </video>
          </AspectRatio>
        </div>
      </div>

      {}
      <div ref={ref} className={`relative z-10 container mx-auto flex flex-col items-center justify-center px-4 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <h2 className="mb-10 max-w-4xl font-sans text-6xl font-extrabold tracking-tighter text-primary drop-shadow-sm md:text-8xl lg:text-9xl uppercase">
          Submit Your Property
        </h2>

        <div className="flex flex-col items-center gap-6">
          <Button asChild className="group h-auto rounded-sm bg-primary px-10 py-6 text-xl font-bold text-primary-foreground shadow-2xl transition-all duration-500 hover:scale-105 hover:bg-primary/90 hover:shadow-black/40">
            <Link to="/SellYourLandPage">
              Get Your Cash Offer
              <ArrowRight className="ml-3 size-6 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Button>

          <Badge variant="outline" className="border-primary/30 bg-primary/5 px-4 py-1.5 text-sm font-mono font-medium tracking-widest text-primary backdrop-blur-sm hover:bg-primary/10">
            Quick Closing Guaranteed
          </Badge>
        </div>
      </div>
    </section>;
}